import React, { useEffect, useState } from 'react'
import { Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useLocation, useNavigate } from 'react-router';
import useApi from '../../../api/useApi';
import { ArticleGet, NewsGet } from '../../../api/orgService';
import { toast } from 'react-toastify';
import SkeletonList from '../../sections/SkeletonList';

function NewsAdminList() {
    const navigate = useNavigate()
        const location = useLocation()
        const [AllArticles,setAllArticles] =useState([])
        // const [nextPageUrl, setNextPageUrl] = useState('http://localhost:8000/api/articles/');
        const [loading, setLoading] = useState(false);
    
        const { request: getAllArticles, data:articleData, error:articleError, isLoading: articleIsLoading} = useApi(NewsGet);
    
              useEffect(() => {
                getAllArticles();
                     // eslint-disable-next-line
                }, []);
                
                useEffect(()=>{
                  if (articleData?.status===200) {
                    setAllArticles(articleData?.data);
                  }
                // eslint-disable-next-line
                },[articleData])
        
              
                // useEffect(()=>{
                //     if(location?.state?.refresh==="org"){
                //       getAllArticles();
                //     }
                //   // eslint-disable-next-line
                //   },[location?.state])
              
                useEffect(()=>{
                    if(articleError){
                        toast.error(`${JSON.stringify(articleError?.response?.data,null,2)}`,{position: "top-center"});
                  }
                },[articleError]) 

    const rows = [
        { id: 1, title: 'Project Test', description: 'the Community version', link: "/staff/article/detail"},
        { id: 2, title: 'Data Grid Pro', description: 'the Pro version', link: "/staff/article/detail?id=1" },
        { id: 3, title: 'Data Grid Premium', description: 'the Premium version', link: "/staff/article/detail?id=1" },
      ];
      
    const columns = [
        { field: 'id', headerName: 'News Number', width: 200 },
        { field: 'title', headerName: 'News Title', width: 200 },
        { field: 'description', headerName: 'Our View Description', width: 300 },
        { field: 'link', headerName: 'View Details', width: 300,
            renderCell: (params) => (
                // <Link
                //   href={params.value}
                //   style={{ color: '#1976d2', textDecoration: 'none', fontWeight: 500 }}
                // >
                //   View details →
                // </Link>
                <Button
                    variant="contained"
                    size="small"
                    onClick={() => navigate(`/staff/article/detail/${params.row.id}/`, {state: { articleId: params.row.id, articleName: params.row.title }})}
                    sx={{
                    textTransform: 'none',
                    backgroundColor: '#1976d2',
                    '&:hover': { backgroundColor: '#115293' },
                    }}
                >
                    View Details →
                </Button>
              ),
         }
    
      ];
    
  if(articleIsLoading){
      return (
        <SkeletonList/>
      )
    }
  return (
    <div style={{ height: '80%', width: '100%' }}>
      <DataGrid rows={AllArticles?.results} columns={columns} />
    </div>
  )
}

export default NewsAdminList